import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, HostListener } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { LambdaService } from 'src/app/lambda.service';
import { ThemingService } from 'src/app/theming.service';
import { SelectProductsModalsComponent } from '../select-products-modals/select-products-modals.component';
import { AddNoteModalComponent } from '../add-note-modal/add-note-modal.component';
import { CreateClientComponent } from '../create-client/create-client.component';
import { ApiService } from 'src/app/api.service';

@Component({
  selector: 'app-create-sale',
  templateUrl: './create-sale.component.html',
  styleUrls: ['./create-sale.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush // Mejor performance
})
export class CreateSaleComponent implements OnInit {

  // Arrays de opciones para los selects
  paymentMethods: any[] = [
    // { value: 'cash', label: 'Cash' },
    // { value: 'credit_card', label: 'Credit Card' },
    // { value: 'debit_card', label: 'Debit Card' },
    // { value: 'bank_transfer', label: 'Bank Transfer' },
    // { value: 'mobile_payment', label: 'Mobile Payment' },
    // { value: 'check', label: 'Check' }
  ];

  // paymentTypes: any[] = [
  //   { value: 'full', label: 'Full Payment' },
  //   { value: 'partial', label: 'Partial Payment' },
  //   { value: 'installments', label: 'Installments' },
  //   { value: 'deposit', label: 'Deposit' }
  // ];

  orderStatuses: any[] = [
    // { value: 0, label: 'Cancelado' },
    { value: 1, label: 'Pendiente de verificación' },
    { value: 2, label: 'Preparando orden' },
    // { value: 3, label: 'Entregado' },
    // { value: 4, label: 'Pendiente Compra Click' },
    { value: 5, label: 'Completado' },
    // { value: 6, label: 'Parcial' }
  ];

  // Variables para guardar las selecciones
  selectedPaymentMethod: number = 15;
  selectedPaymentType: string = '';
  selectedOrderStatus: number = 1;

  // Estados del componente
  orderProducts: any[] = [];
  orderSummary: any = {
    subtotal: 0,
    discount: 0,
    shipping: 0,
    tax: 0,
    total: 0,
    itemCount: 0,
    taxCalculated: false
  };
  currentCustomer: any = null;
  // notes: any[] = [];
  notes: string = "";
  
  // Búsqueda de cliente
  customerSearchQuery = '';
  customerSearchResults: any[] = [];
  showCustomerResults = false;
  isCreatingNewCustomer = false;
  clients: any;
  
  // Formulario para nuevo cliente
  newCustomerForm: FormGroup;
  
  // Loading states
  isLoadingProducts = false;
  isLoadingCustomers = false;

  loading: boolean = false
  showCustomerDropdown = false;
  allCustomers: any[] = [];

  shopPoints: any[] = [];
  paymentTypes: any[] = [];
  currentShopPoint: any = null;
  isCreatingOrder: boolean = false;
  currency: string = '₡';

  // Control del modal de resultado
  showResultModal: boolean = false;
  resultModalType: 'success' | 'error' = 'success';
  resultModalMessage: string = '';
  private resultModalInstance: any;

  @HostListener('document:keydown.escape')
  onEscapeKey(): void {
    if (this.showResultModal) {
      this.closeResultModal();
    }
  }

  constructor(
    private fb: FormBuilder,
    public dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private lambdaService: LambdaService,
    private themingService: ThemingService,
    private apiService: ApiService,
    // Aquí inyectarás tu servicio de API cuando lo necesites
    // private apiService: YourApiService
  ) {
    this.newCustomerForm = this.fb.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phone: ['']
    });

    this.loadAllCustomers();
  }

  async ngOnInit(): Promise<void> {
    console.log('CreateSaleComponent initialized');
    
    // 1. Inicializar arrays vacíos para evitar errores de "undefined"
    this.clients = [];
    this.shopPoints = [];

    // 2. Cargar clientes y esperar a que termine (opcional, pero recomendado)
    await this.getClients();

    try {
      // 3. Manejo seguro de la respuesta asíncrona
      const response: any = await this.lambdaService.getPaymentMethods(this.themingService.shopId);
      
      const paymentTypes = Array.isArray(response?.paymentTypes) ? response.paymentTypes : [];
      const paymentMethods = Array.isArray(response?.paymentMethods) ? response.paymentMethods : [];
      
      this.paymentMethods = paymentMethods;
      this.paymentTypes = paymentTypes.filter((pt: any) => 
        this.paymentMethods.some((pm: any) => pm.paymentTypeId === pt.paymentTypeId)
      );

      const backofficePaymentType = response?.paymentTypes?.find((pt: any) => pt.paymentTypeId === 15);
      if (backofficePaymentType) {
        this.paymentTypes.unshift(backofficePaymentType);
      }

      // 4. ACCESO SEGURO a shopTheming (evita el crash si aún no está listo)
      const currentTheming = this.themingService.shopTheming?.[0];
      
      if (currentTheming) {
        this.shopPoints = currentTheming.shopsLocation || [];
        this.currency = currentTheming.currencyCode !== "CRC" ? "$" : "₡";
        this.currentShopPoint = this.shopPoints.length > 0 ? this.shopPoints[0].shopPointId : null;
      } else {
        console.warn('themingService.shopTheming[0] aún no está disponible');
      }

      // 5. ¡CRUCIAL! Avisar a Angular que actualice la vista por el OnPush
      this.cdr.markForCheck();

    } catch (error) {
      console.error('Error cargando métodos de pago o configuración:', error);
    }
  }
  // ==================== PRODUCTOS ====================

  openSelectProductsModal(): void {
    const dialogRef = this.dialog.open(SelectProductsModalsComponent, {
      width: '700px',
      maxHeight: '80vh',
      disableClose: false,
      data: {
        existingProducts: this.orderProducts
      }
    });

    dialogRef.afterClosed().subscribe((selectedProducts: any[]) => {
      if (selectedProducts && selectedProducts.length > 0) {
        // console.log('Selected products from modal:', selectedProducts);
        selectedProducts.forEach(product => {
          this.addProductToOrder(product);
        });
      }
    });
  }

  updateQuantity(index: number, amount: number): void {
    if (amount < 1) amount = 1;
    
    const products = [...this.orderProducts];
    products[index].amount = amount;
    products[index].amount = parseInt(products[index].amount)
    // Recalcular line total
    if (products[index] && products[index].itemPrice) {
      products[index].lineTotal = amount * products[index].itemPrice;
    }
    
    this.orderProducts = products;
    this.calculateSummary();
    this.cdr.markForCheck()
  }

  removeProduct(index: number): void {
    const products = this.orderProducts.filter((_, i) => i !== index);
    this.orderProducts = products;
    this.calculateSummary();
    this.cdr.markForCheck()
  }

  addProductToOrder(productData: any): void {
    // Este método será llamado desde el modal de productos
    this.isLoadingProducts = true;
    const existingIndex = this.orderProducts.findIndex(
      p => p.itemId === productData.itemId
    );

    const newProducts = [...this.orderProducts];
    if (existingIndex >= 0) {
      // Si ya existe, aumentar cantidad
      newProducts[existingIndex].amount = parseInt(newProducts[existingIndex].amount) + 1;
      newProducts[existingIndex].lineTotal = parseInt(newProducts[existingIndex].amount) * newProducts[existingIndex].itemPrice;
    } else {
      // Si no existe, agregar nuevo
      newProducts.push({
        variant: productData.variantValues ? productData.variantValues[0] : "",
        amount: 1,
        lineTotal: productData.itemPrice,
        productName: productData.productName,
        imageURL: productData.imageURL,
        itemId: productData.itemId,
        itemCode: productData.itemCode,
        itemPrice: productData.itemPrice,
        itemShopPointId: this.currentShopPoint || productData.itemShopPointId
      });
    }
    this.orderProducts = newProducts;
    // console.log('Updated order products:', this.orderProducts);
    this.calculateSummary();
    this.cdr.markForCheck()
    this.isLoadingProducts = false;
  }

  // ==================== CLIENTES ====================

  async getClients() {
    await this.lambdaService
    .getClients(
      this.themingService.shopId,
      this.customerSearchQuery,
      0,
      this.customerSearchQuery == "" ? 500 : 1000,
      "DESC"
    )
    .then((data: any) => {
      this.clients = data.data;
      // this.totalPages = data.pagination[0].lastPage;
      // this.formatPages()
    }).catch((error: Error)=>{
      console.log(error)
    })
    // console.log('Fetched clients:', this.clients);
  }

  loadAllCustomers(): void {
    // Aquí llamarías a tu API para obtener todos los clientes
    // this.apiService.getCustomers().subscribe(customers => {
    //   this.allCustomers = customers;
    // });
    
    // Mock data temporal
    this.allCustomers = [
      { id: '1', name: 'Juan Pérez', email: 'juan@email.com', ordersCount: 3 },
      { id: '2', name: 'María García', email: 'maria@email.com', ordersCount: 5 },
      { id: '3', name: 'Carlos López', email: 'carlos@email.com', ordersCount: 1 },
      // ... más clientes
    ];
  }

  onCustomerSearchChange(query: string): void {
    this.customerSearchQuery = query;
    this.getClients();
    // console.log('Customer search query:', query);
    // Si hay query, filtra; si no, muestra TODOS los clientes
    if (query.trim().length > 0) {
      const lower = query.toLowerCase();
      // this.customerSearchResults = this.allCustomers.filter(c =>
      this.customerSearchResults = this.clients.filter((c:any) =>
        // c.name.toLowerCase().includes(lower) ||
        c.firstName.toLowerCase().includes(lower) ||
        c.lastName.toLowerCase().includes(lower) ||
        c.nationalId.toLowerCase().includes(lower) ||
        c.email.toLowerCase().includes(lower)
      );
    } else {
      // IMPORTANTE: Si no hay búsqueda, muestra TODOS los clientes
      // this.customerSearchResults = [...this.allCustomers];
      this.customerSearchResults = [...this.clients];
    }
  }

  // Cuando el input recibe focus
  onCustomerFocus(): void {
    // Asegúrate de tener los clientes cargados
    if (this.allCustomers.length === 0) {
      this.loadAllCustomers();
    }
    
    // Muestra todos los clientes
    // this.customerSearchResults = [...this.allCustomers];
    this.customerSearchResults = [...this.clients];
    this.showCustomerResults = true;
    this.isCreatingNewCustomer = false;
  }

  searchCustomers(query: string): void {
    // Aquí llamarás a tu API para buscar clientes
    // this.apiService.searchCustomers(query).subscribe(results => { ... });
    
    // Mock temporal - eliminar cuando tengas la API
    this.customerSearchResults = [
      { id: '1', name: 'Cliente Ejemplo 1', email: 'cliente1@email.com', ordersCount: 2 },
      { id: '2', name: 'Cliente Ejemplo 2', email: 'cliente2@email.com', ordersCount: 5 }
    ];
    this.showCustomerResults = true;
  }

  selectCustomer(customer: any): void {
    // console.log("clicked:",customer);
    this.currentCustomer = customer;
    this.customerSearchQuery = customer.name;
    this.showCustomerResults = false;
    this.isCreatingNewCustomer = false;
  }

  toggleNewCustomer(): void {
    // console.log("Toggling new customer modal");
    const dialogRef = this.dialog.open(CreateClientComponent, {
      width: '1024px',
      maxHeight: '60vh',
      panelClass: 'no-padding-modal'
    });

    dialogRef.afterClosed().subscribe((customer) => {
      // if (customer) {
      //   this.allCustomers.push(customer);
      //   this.selectCustomer(customer);
      //   this.cdr.markForCheck();
      // }
      // console.log('customer:', customer);
      this.getClients();
    });
  }

  createNewCustomer(): void {
    if (this.newCustomerForm.valid) {
      // Aquí llamarás a tu API para crear el cliente
      // this.apiService.createCustomer(this.newCustomerForm.value).subscribe(customer => { ... });
      
      const newCustomer = {
        id: `temp_${Date.now()}`,
        ...this.newCustomerForm.value,
        ordersCount: 0
      };
      
      this.currentCustomer = newCustomer;
      this.customerSearchQuery = newCustomer.name;
      this.isCreatingNewCustomer = false;
      this.newCustomerForm.reset();
    }
  }

  clearCustomer(): void {
    this.currentCustomer = null;
    this.customerSearchQuery = '';
  }

  // ==================== NOTAS ====================

  openAddNoteModal(): void {
    const dialogRef = this.dialog.open(AddNoteModalComponent, {
      width: '600px',
      disableClose: false,
      data: {
        notes: this.notes
      }
    });

    dialogRef.afterClosed().subscribe((noteText: string) => {
      if (noteText && noteText.trim()) {
        this.notes = noteText.trim();
      }
    });
  }

  // ==================== CÁLCULOS ====================

  calculateSummary(): void {
    const subtotal = this.orderProducts.reduce((sum, product) => {
      return sum + (product.lineTotal || 0);
    }, 0);

    const itemCount = this.orderProducts.reduce((sum, product) => {
      return sum + (product.quantity || 0);
    }, 0);

    this.orderSummary = {
      subtotal,
      discount: this.orderSummary.discount || 0,
      shipping: this.orderSummary.shipping || 0,
      tax: this.orderSummary.tax || 0,
      total: subtotal - (this.orderSummary.discount || 0) + (this.orderSummary.shipping || 0) + (this.orderSummary.tax || 0),
      itemCount,
      taxCalculated: this.orderSummary.taxCalculated || false
    };
  }

  // ==================== HELPERS ====================

  get hasProducts(): boolean {
    return this.orderProducts.length > 0;
  }

  formatCurrency(amount: number): string {
    if (amount === null || amount === undefined) return this.currency + '0.00';
    return `${this.currency}${amount.toLocaleString('es-CR', { 
      minimumFractionDigits: 2, 
      maximumFractionDigits: 2 
    })}`;
  }

  // ==================== MOCK DATA (Temporal) ====================
  
  loadMockData(): void {
    // Datos de prueba para desarrollo - eliminar en producción
    this.orderProducts = [
      {
        variant: {
          id: 'v1',
          productName: 'ABRIGO',
          productImage: 'assets/images/abrigo1.png',
          size: 'M',
          sku: 'AC31VE',
          price: 12800.00,
          available: 89
        },
        quantity: 1,
        lineTotal: 12800.00
      },
      {
        variant: {
          id: 'v2',
          productName: 'ABRIGO',
          productImage: 'assets/images/abrigo2.png',
          size: 'S',
          sku: 'MI15CA',
          price: 24800.00,
          available: 1
        },
        quantity: 1,
        lineTotal: 24800.00
      }
    ];
    
    this.calculateSummary();
  }

  // ==================== CREATE SALE ====================

  async createSale(){

    // console.log(this.orderProducts);
    // console.log(this.currentCustomer);
    // console.log(this.themingService.shopTheming[0].shopsLocation);

    // Validaciones previas
    if (this.isCreatingOrder) return; // Evita doble click
    
    if (!this.currentCustomer) {
      alert('Please select a customer');
      return;
    }
    
    if (this.orderProducts.length === 0) {
      alert('Please add at least one product');
      return;
    }

    this.isCreatingOrder = true; // Activa el loading


    await this.apiService
    .sendSale(
      this.themingService.shopTheming[0].shopId,
      this.currentShopPoint,
      false,
      0,
      this.selectedPaymentMethod,
      this.orderProducts,
      [],
      [],
      this.currentCustomer.firstName+ " " + this.currentCustomer.lastName,
      this.currentCustomer.nationalId,
      this.currentCustomer.phone,
      this.currentCustomer.email,
      this.notes || "Backoffice",
      "",
      "",
      "",
      "",
      "",
      "",
      0,
      2,
      "",
      false,
      4,
      this.selectedOrderStatus
    )
    .then(async (data: any) => {
      if(data && data.msg == "success" && data.saleId > 0){
        // console.log("SUCCESS: ", data);
        this.showResultModalMessage('success', 'Order created successfully!');
        // ✅ RESET: Limpiar productos y cliente
        this.resetOrder();
      } else {
        throw new Error(data?.message || "Sale creation failed");
      }
    })
    .catch((error: any) => {
      // console.error("ERROR: ", error);
      this.showResultModalMessage('error', error?.message || 'Error creating order. Please try again.');
    })
    .finally(() => {
      this.isCreatingOrder = false; // Desactiva el loading
    });
  }

  // Método para mostrar el modal
  showResultModalMessage(type: 'success' | 'error', message: string): void {
    this.resultModalType = type;
    this.resultModalMessage = message;
    this.cdr.markForCheck(); // Actualiza la vista antes de abrir el modal

    // Espera un tick para que Angular renderice el contenido
    setTimeout(() => {
      const modalElement = document.getElementById('resultModal');
      if (modalElement && !this.resultModalInstance) {
        this.resultModalInstance = new (window as any).bootstrap.Modal(modalElement);
      }
      this.resultModalInstance?.show();
    }, 100);
  }

  // Método para cerrar el modal
  closeResultModal(): void {
    this.resultModalInstance?.hide();
    if (this.resultModalType === 'success') {
      this.resetOrder();
    }
  }

  resetOrder(): void {
    // Limpiar productos
    this.orderProducts = [];
    
    // Limpiar cliente
    this.currentCustomer = null;
    this.customerSearchQuery = '';

    // ✅ Limpiar detalles de la orden
    this.selectedPaymentMethod = 15;
    this.currentShopPoint = this.shopPoints[0].shopPointId;
    this.selectedOrderStatus = 1;
    
    // Resetear resumen de pago
    this.orderSummary = {
      subtotal: 0,
      discount: 0,
      shipping: 0,
      tax: 0,
      total: 0,
      itemCount: 0,
      taxCalculated: false
    };
    
    // Forzar actualización de la vista (por OnPush)
    this.cdr.markForCheck();
  }

  onOrderDetailsChange(): void {
    // Aquí puedes hacer validaciones o acciones cuando cambie algún select
    // console.log('Order details changed:', {
    //   paymentMethod: this.selectedPaymentMethod,
    //   shopPoint: this.currentShopPoint,
    //   orderStatus: this.selectedOrderStatus
    // });
    
    this.cdr.markForCheck();
  }

}